<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top" style="position: relative">
  <div class="w-100 center-items">
    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12" style="padding-left: 0 !important">
      <mat-form-field class="with__underline" id="search__field">
        <input [formControl]="searchCtrl" matInput (keyup)="_filterGeneralByField($event.target.value)"
          placeholder="Filtrar por nombre" autocomplete="off" />
      </mat-form-field>
    </div>
    <div class="inline-items">
      <button mat-stroked-button matTooltip="Agregar nuevo Colaborador" class="stroked-btn" (click)="addNewNomina()"
        type="button">
        Agregar Colaborador
      </button>
      <button mat-stroked-button class="stroked-btn" type="button" (click)="openDialogFile()"
        matTooltip="Carga Nomina" style="width: 60px">
        <mat-icon>attach_file</mat-icon>
      </button>
      <button mat-stroked-button class="stroked-btn" type="button" color="primary" (click)="validateDatosPost()"
        >
        Solicitar financiamiento
      </button>

    </div>
  </div>

  @if (hasError) {
    <div class="container__message">
      <div class="warning-msg animate__animated animate__fadeIn" style="background: white !important; padding-left: 0;">
        <span class="material-symbols-outlined" style="color:#ff933b;">error</span>
        &nbsp; Revisa los errores en la información proporcionada.
      </div>
    </div>
  }

  @if (noDataFiltered) {
    <div style="width: 100%">
      <div class="empty__message">
        <span class="material-symbols-outlined" style="font-size: 20px">tips_and_updates</span>
        <p>No hay resultados para la busqueda</p>
      </div>
    </div>
  }

  <div class="table-responsive-simpli add_factoring" style="margin-top: 20px">

    @if (noDataRow) {
      <div class="container__message">
        <div class="warning-msg animate__animated animate__fadeIn" style="background: white !important; padding-left: 0;">
          <span class="material-symbols-outlined" style="color:#ff933b;">error</span>
          &nbsp; Debes agregar al menos un colaborar para continuar.
        </div>
      </div>
    }

    @if (dataSource.data.length > 0 || !noDataFiltered || !noDataRow) {
      <form [formGroup]="form">
        <div class="table-responsive-simpli add_factoring">
          <table mat-table [dataSource]="dataSource" formArrayName="nomina" style="width: 100%">
            <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
            <tr mat-row *matRowDef="let row; let i = index; columns: displayColumns"></tr>
            <ng-container matColumnDef="delete">
              <th mat-header-cell *matHeaderCellDef style="width: 50px !important;"></th>
              <td style="width: 50px !important;" mat-cell *matCellDef="let row; let index = index" [formGroupName]="getActualIndex(index)">
                <div class="input__icon">
                  <span matTooltip="Eliminar Colaborador" (click)="deleteEmpleado(row,index)">
                    <span class="material-symbols-outlined deleteicon">remove_circle</span>
                  </span>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Nombre</th>
              <td mat-cell *matCellDef="let row; let index = index" [formGroupName]="getActualIndex(index)">
                <div class="input__icon">
                  <mat-form-field class="mat-sm" [floatLabel]="labelFloat" appearance="outline">
                    <input matInput class="no-input" formControlName="name" placeholder="Nombre" required />
                    @if (validateField('name',row,index,'errorName') || !validateIncorrect('name',row,index,'errorName')) {
                      <mat-error
                        >
                        El nombre es <strong>requerido</strong>
                      </mat-error>
                    }
                    @if (validateIncorrect('name',row,index,'errorName')) {
                      <mat-hint align="center" class="mat-error">
                        El nombre es <strong>incorrecto</strong>
                      </mat-hint>
                    }
                  </mat-form-field>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="rut">
              <th mat-header-cell *matHeaderCellDef>Rut</th>
              <td mat-cell *matCellDef="let row; let index = index" [formGroupName]="getActualIndex(index)">
                <mat-form-field class="mat-sm" [floatLabel]="labelFloat" appearance="outline">
                  <input class="no-input" matInput formControlName="rut" placeholder="Rut" required
                    (keyup)="onChangeInputRut($event, row, index)" />
                  @if (validateField('rut',row,index,'errorRut') || !validateIncorrect('rut',row,index,'errorRut')) {
                    <mat-error
                      >
                      El rut es <strong>requerido</strong>
                    </mat-error>
                  }
                  @if (validateIncorrect('rut',row,index,'errorRut')) {
                    <mat-hint align="center" class="mat-error">
                      El rut es <strong>incorrecto</strong>
                    </mat-hint>
                  }
                </mat-form-field>
              </td>
            </ng-container>
            <ng-container matColumnDef="number">
              <th mat-header-cell *matHeaderCellDef>Cuenta</th>
              <td mat-cell *matCellDef="let row; let index = index" [formGroupName]="getActualIndex(index)">
                <mat-form-field class="mat-sm" [floatLabel]="labelFloat" appearance="outline">
                  <input matInput class="no-input" formControlName="number" placeholder="N.Cuenta" required />
                  @if (validateField('number',row,index,'errorNumber') || !validateIncorrect('number',row,index,'errorNumber')) {
                    <mat-error
                      >
                      El número de cuenta es <strong>requerido</strong>
                    </mat-error>
                  }
                  @if (validateIncorrect('number',row,index,'errorNumber')) {
                    <mat-hint align="center" class="mat-error">
                      El número de cuenta es <strong>incorrecto</strong>
                    </mat-hint>
                  }
                </mat-form-field>
              </td>
            </ng-container>
            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef>Email</th>
              <td mat-cell *matCellDef="let row; let index = index" [formGroupName]="getActualIndex(index)">
                <mat-form-field class="mat-sm" [floatLabel]="labelFloat" appearance="outline">
                  <input matInput class="no-input" type="email" formControlName="email" placeholder="Email" required />
                  @if (validateField('email',row,index,'errorEmail') || !validateIncorrect('email',row,index,'errorEmail')) {
                    <mat-error
                      >
                      El email es <strong>requerido</strong>
                    </mat-error>
                  }
                  @if (validateIncorrect('email',row,index,'errorEmail')) {
                    <mat-hint align="center" class="mat-error">
                      Formato de email <strong>incorrecto</strong>
                    </mat-hint>
                  }
                </mat-form-field>
              </td>
            </ng-container>
            <ng-container matColumnDef="amount">
              <th mat-header-cell *matHeaderCellDef>Monto</th>
              <td mat-cell *matCellDef="let row; let index = index" [formGroupName]="getActualIndex(index)">
                <mat-form-field class="mat-sm" [floatLabel]="labelFloat" appearance="outline">
                  <input matInput class="no-input" formControlName="amount" placeholder="Monto"
                    (keyup)="onChangeInput($event, row, index)" required />
                  @if (validateField('amount',row,index,'errorAmount') || !validateIncorrect('amount',row,index,'errorAmount')) {
                    <mat-error
                      >
                      El monto es <strong>requerido</strong>
                    </mat-error>
                  }
                  @if (validateIncorrect('amount',row,index,'errorAmount')) {
                    <mat-hint align="center" class="mat-error">
                      Monto <strong>incorrecto</strong>
                    </mat-hint>
                  }
                </mat-form-field>
              </td>
            </ng-container>
            <ng-container matColumnDef="banco">
              <th mat-header-cell *matHeaderCellDef style="width: 200px">Banco</th>
              <td mat-cell *matCellDef="let row; let index = index" [formGroupName]="getActualIndex(index)">
                <mat-form-field class="mat-sm" [floatLabel]="labelFloat" appearance="outline">
                  <mat-select formControlName="id_bank" placeholder="Banco">
                    @for (banco of bancos; track banco) {
                      <mat-option [value]="banco.id">
                        {{ banco.name }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (validateField('id_bank',row,index,'errorBank') || !validateIncorrect('id_bank',row,index,'errorBank')) {
                    <mat-error
                      >
                      El banco es <strong>requerido</strong>
                    </mat-error>
                  }
                  @if (validateIncorrect('id_bank',row,index,'errorBank')) {
                    <mat-hint align="center" class="mat-error">
                      Banco <strong>incorrecto</strong>
                    </mat-hint>
                  }
                </mat-form-field>
              </td>
            </ng-container>
            <ng-container matColumnDef="tipo">
              <th mat-header-cell *matHeaderCellDef style="width: 200px">
                Tipo de Cuenta
              </th>
              <td mat-cell *matCellDef="let row; let index = index" [formGroupName]="getActualIndex(index)">
                <mat-form-field class="mat-sm" [floatLabel]="labelFloat" appearance="outline">
                  <mat-select formControlName="id_type" placeholder="Tipo de Cuenta">
                    @for (type of accountType; track type) {
                      <mat-option [value]="type.id">
                        {{ type.name }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (validateField('id_type',row,index,'errorType') || !validateIncorrect('id_type',row,index,'errorType')) {
                    <mat-error
                      >
                      Tipo de cuenta <strong>requerido</strong>
                    </mat-error>
                  }
                  @if (validateIncorrect('id_type',row,index,'errorType')) {
                    <mat-hint align="center" class="mat-error">
                      Tipo de cuenta <strong>incorrecto</strong>
                    </mat-hint>
                  }
                </mat-form-field>
              </td>
            </ng-container>
            <ng-container matColumnDef="check">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let row; let index = index; let i = index" style="text-align: center"
                matTooltip="{{getMatTooltipError(row)}}">
                @if (
                  row.value.error == false &&
                  row.value.errorRemuneraciones == false
                  ) {
                  <span class="material-symbols-outlined" style="color: #3BA46F">check_circle</span>
                }
                @if (
                  row.value.error == true &&
                  row.value.errorRemuneraciones == false
                  ) {
                  <span class="material-symbols-outlined" style="color: #ff933b">error</span>
                }
                @if (
                  row.value.error == true && row.value.errorRemuneraciones == true
                  ) {
                  <span class="material-symbols-outlined" style="color: #fa454c">cancel</span>
                }
              </td>
            </ng-container>
          </table>
        </div>
      </form>
    }
  </div>
  <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>

</div>
